import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { get as getProjection } from 'ol/proj';

import projections from 'app/config/projections'

export default class {

    run(){

        for(const projection of projections) {
            proj4.defs(projection.title, projection.definition);
        }

        register(proj4);

        for(const projection of projections) {

            const proj = getProjection(projection.title);
            proj.setExtent(projection.extent);
            proj.setWorldExtent(projection.worldExtent);
        }
    }
}